<template>
    <v-container>

        <v-row>
            <v-col>
                <div class="font-weight-bold mt-10 title-page">Início</div>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <span class="page-subtitle text-justify">Bem-vindo(a) ao site oficial da Administração Judicial da
                    Recuperação
                    Judicial do
                    Grupo 123 Milhas</span>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <p class="text-justify">
                    Em 31/08/2023, o Grupo 123 Milhas teve autorizado o processamento do pedido de Recuperação Judicial.
                    Foram
                    nomeados para atuar como Administradores Judiciais (auxiliares do Poder Judiciário), conjuntamente,
                    Paoli Balbino & Barros
                    Advogados e Brizola e Japur Administração Judicial (responsáveis pelo presente canal de comunicação).
                    Para saber mais sobre o
                    processo, consulte a aba “SOBRE O PROCESSO”.
                </p>
            </v-col>
        </v-row>
        <v-row>
            <v-col align="center">
                <span class="page-subtitle font-weight-bold">CONSULTE JÁ A LISTA OFICIAL DE TODAS AS PESSOAS COM VALORES A
                    RECEBER ENVIADA PELO GRUPO 123 MILHAS
                </span>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <p class="text-justify">
                    Ainda não foi disponibilizada pelo Juízo a lista oficial encaminhada pelo Grupo 123 Milhas, contendo os
                    nomes das pessoas com valores a receber na Recuperação Judicial (Edital do art. 52, § 1o, da Lei
                    11.101/2005).
                    <br>
                    <br>
                    A partir da publicação, abrirá o prazo de 15 (quinze) dias para pedidos de HABILITAÇÃO DE CRÉDITO
                    (inclusão do nome) ou DIVERGÊNCIA DE CRÉDITO (exclusão de nome ou correção de valores).
                    <br>
                    <br>
                    Apesar disso, tendo em vista que a Administração Judicial já recebeu as informações necessárias pelas
                    empresas para início da fase de verificação de créditos (art. 7o, § 1o, da Lei 11.101/2005), informamos
                    que <strong>ESTÁ ABERTA A PLATAFORMA PARA APRESENTAÇÃO DOS PEDIDOS DE HABILITAÇÃO E
                        DIVERGÊNCIAS.</strong>
                    <br>
                    <br>
                    <strong>ATENÇÃO!</strong> A Administração Judicial do processo de Recuperação Judicial receberá os
                    <strong>pedidos exclusivamente
                        neste site</strong>, na aba "ÁREA CREDOR", através de formulário específico e especialmente
                    desenvolvido para
                    atender aos credores consumidores, tendo em vista os 797.152 créditos quirografários arrolados em nomes
                    de pessoa física.
                    <br>
                    <br>
                    <strong>NÃO SÃO ACEITAS HABILITAÇÕES OU DIVERGÊNCIAS DENTRO DO PROCESSO NESTE MOMENTO</strong>, conforme
                    decisões de ID
                    9912619803 e ID 9908103191 (consulte na aba "SOBRE O PROCESSO").
                    <br>
                    <br>
                    <strong>FIQUE ATENTO: Assim que publicado o Edital, passará a contar o prazo de 15 (quinze) dias e este
                        irá
                        demarcar a data final para envio dos pedidos e documentos.</strong>
                    <br>
                    <br>
                    <a href="#" @click="openRegister">Cadastre-se aqui</a> e confira se seu nome foi incluído.
                </p>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogPopup" :width="700">
            <v-img src="@/assets/images/popup-home.jpeg">
                <div align="right">
                    <v-btn icon elevation="0" @click="dialogPopup = false"><v-icon>mdi-close</v-icon></v-btn>
                </div>
            </v-img>
        </v-dialog>

    </v-container>
</template>

<script>
import 'moment/locale/pt-br';

import { eventHub } from "@/main"

export default {
    data: () => ({
        user: null,
        dialogPopup: false
    }),

    mounted: function () {
    },

    created() {
        this.$ga.event({
            eventCategory: 'page',
            eventAction: 'action',
            eventLabel: 'click',
            eventValue: 'home'
        })

        this.dialogPopup = true;
    },

    methods: {
        openRegister() {
            eventHub.$emit("DIALOG-REGISTER", true)
        }
    }
};
</script>

<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}
</style>
